import { render } from "./ReminderHome.vue?vue&type=template&id=c79ede9c&scoped=true"
import script from "./ReminderHome.vue?vue&type=script&lang=js"
export * from "./ReminderHome.vue?vue&type=script&lang=js"

import "./ReminderHome.vue?vue&type=style&index=0&id=c79ede9c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79ede9c"]])

export default __exports__